"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.Indicator = function (_a) {
    var color = _a.color;
    return (React.createElement("svg", { height: "10px", width: "10px", viewBox: "0 0 10 10", style: {
            boxShadow: "0px 0px 28px 0px " + color
        } },
        React.createElement("circle", { fill: color, r: 5, cx: 5, cy: 5 })));
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/indicator.js
 ** module id = 152
 ** module chunks = 0
 **/